// extracted by mini-css-extract-plugin
export default {"inheritWidth":"styles__inheritWidth___SvmxG","payNowFooter":"styles__payNowFooter___hAU5G","prePaymentAmount":"styles__prePaymentAmount___JgD9V"};